<p-dialog
    header="Edit Variant"
    [visible]="visibleSignal()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '40rem' }"
    [breakpoints]="{ '960px': '95vw' }"
    appendTo="body"
    [modal]="true"
    [closable]="!saving()"
    [draggable]="false"
>
    @if (editingVariant(); as v) {
        <div class="flex flex-col gap-4" (keydown.control.enter)="save()" (keydown.meta.enter)="save()">
            <div class="text-xs text-muted-color">
                Toggle <span class="font-medium">Override</span> to set a realm-specific value.
                Otherwise the template value is used. Mode config is managed on the game server.
            </div>

            <div class="flex flex-col gap-3 p-3 bg-surface-50 dark:bg-surface-800 rounded">
                <div class="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1 text-xs">
                    <div class="flex flex-col gap-0.5">
                        <span class="text-muted-color uppercase tracking-wide">Type</span>
                        <span class="font-medium">{{ modeConfigTypeLabel(v.Template.ModeConfig) }}</span>
                    </div>
                    <div class="flex flex-col gap-0.5">
                        <span class="text-muted-color uppercase tracking-wide">Players</span>
                        <span class="font-medium inline-flex items-center gap-1">
                            <i class="pi pi-users text-xs"></i>
                            {{ variantPlayerCount(v.Template.ModeConfig) ?? '—' }}
                        </span>
                    </div>
                    <div class="flex flex-col gap-0.5">
                        <span class="text-muted-color uppercase tracking-wide">Entry Fee</span>
                        <span class="font-medium">
                            @switch (variantEntryFee(v.Template.ModeConfig).kind) {
                                @case ('fixed') {
                                    <app-funds-display [funds]="$any(variantEntryFee(v.Template.ModeConfig)).funds" />
                                }
                                @case ('range') {
                                    {{ $any(variantEntryFee(v.Template.ModeConfig)).min }}–{{ $any(variantEntryFee(v.Template.ModeConfig)).max }}
                                    <span class="text-muted-color">({{ $any(variantEntryFee(v.Template.ModeConfig)).currency }})</span>
                                }
                                @default { — }
                            }
                        </span>
                    </div>
                    <div class="flex flex-col gap-0.5">
                        <span class="text-muted-color uppercase tracking-wide">Reward (1st)</span>
                        <span class="font-medium inline-flex items-center gap-1">
                            @if (variantTopReward(v.Template.ModeConfig); as r) {
                                <i class="pi pi-trophy text-xs"></i>
                                <app-funds-display [funds]="r" />
                            } @else {
                                —
                            }
                        </span>
                    </div>
                </div>
                <div class="text-xs text-muted-color">
                    Template ID: {{ v.Template.GameVariantTemplateId }}
                </div>
                @if (v.Template.Notes) {
                    <div class="text-xs text-muted-color">
                        <span class="font-medium">Notes:</span> {{ v.Template.Notes }}
                    </div>
                }
            </div>

            <!-- DisplayInfo override -->
            <div class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700">
                <div class="flex items-center gap-2">
                    <p-checkbox
                        inputId="edit-ovr-display"
                        [binary]="true"
                        [ngModel]="draft().overrideDisplayInfo"
                        (ngModelChange)="toggleDisplayOverride($event)"
                    />
                    <label for="edit-ovr-display" class="font-medium">Override display info</label>
                </div>
                <div class="flex flex-col gap-3 pl-6">
                    <div class="flex flex-col gap-1">
                        <label class="text-sm font-medium">Name @if (draft().overrideDisplayInfo) { <span class="text-red-500">*</span> }</label>
                        <input
                            pInputText
                            [ngModel]="draft().displayName"
                            (ngModelChange)="setField('displayName', $event ?? '')"
                            [disabled]="!draft().overrideDisplayInfo"
                        />
                    </div>
                    <div class="flex flex-col gap-1">
                        <label class="text-sm font-medium">Description</label>
                        <textarea
                            pTextarea
                            rows="2"
                            [ngModel]="draft().displayDescription"
                            (ngModelChange)="setField('displayDescription', $event ?? '')"
                            [disabled]="!draft().overrideDisplayInfo"
                        ></textarea>
                    </div>
                </div>
            </div>

            <!-- IsActive override -->
            <div class="flex flex-col gap-2 pt-2 border-t border-surface-200 dark:border-surface-700">
                <div class="flex items-center gap-2">
                    <p-checkbox
                        inputId="edit-ovr-active"
                        [binary]="true"
                        [ngModel]="draft().overrideIsActive"
                        (ngModelChange)="toggleActiveOverride($event)"
                    />
                    <label for="edit-ovr-active" class="font-medium">Override active</label>
                </div>
                @if (draft().overrideIsActive) {
                    <div class="flex items-center gap-2 pl-6">
                        <p-checkbox
                            inputId="edit-active-val"
                            [binary]="true"
                            [ngModel]="draft().isActive"
                            (ngModelChange)="setField('isActive', $event)"
                        />
                        <label for="edit-active-val" class="text-sm">{{ draft().isActive ? 'Active' : 'Inactive' }}</label>
                    </div>
                } @else {
                    <div class="text-xs text-muted-color pl-6">
                        Inherits from template: {{ templateActiveLabel() }}
                    </div>
                }
            </div>

            @if (saveError()) {
                <p-message severity="error" [text]="saveError()!" />
            }
        </div>
    }

    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" outlined [disabled]="saving()" (onClick)="close()" />
            <p-button
                label="Save"
                icon="pi pi-check"
                [loading]="saving()"
                [disabled]="!canSave()"
                (onClick)="save()"
            />
        </div>
    </ng-template>
</p-dialog>
